import * as React from 'react';
import MenuItem from 'components/MenuItem';
import ModalTrigger from 'components/ModalTrigger';
import { Props as MenuItemProps } from 'components/MenuItem';

type Props = {
  modal: React.ReactElement;
  eventKey?: string;
} & DefaultProps &
  MenuItemProps;

type DefaultProps = {
  disabled: boolean;
};

class ModalMenuItem extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    disabled: false,
  };

  render() {
    let menuItem = <MenuItem {...this.props}>{this.props.children}</MenuItem>;

    if (!this.props.disabled) {
      menuItem = <ModalTrigger modal={this.props.modal}>{menuItem}</ModalTrigger>;
    }

    return menuItem;
  }
}

export default ModalMenuItem;
